import React from 'react'
import { Avatar } from '@material-ui/core'
import './SidebarChat.css'

function SidebarChat(props) {
  const handleChatClick =()=>{
    props.selectedMessage(props.message)
  }
  const lastMessageSaample = ()=>{
    if(props.message){
      const msgArrayLenght = props.message.msg.length-1
      if(props.message.msg[msgArrayLenght].type == "text_message"){
        return props.message.msg[msgArrayLenght].body.substring(0,30)
      }else{
        return '...'
      }
      
    }else{
      return "..."
    }
  }
  return (
    <div className='sidebarChat mb--4' onClick={handleChatClick}>
        <Avatar/>
        <div className="sidebarChat__info">
            <h2>{props.message && props.message.msg[0].name + " " + props.message._id.phone} </h2>
            <p> {lastMessageSaample()} </p>
        </div>
    </div>
  )
}

export default SidebarChat